import { MedicalDataTypes } from '../primary-record-types';
import { medicationFrequency } from './sharedMessages';

export const getDosageInstructions = (medication: MedicalDataTypes.PrimaryRecordMedication): string => {
    const frequencyText = medication.frequency ? medicationFrequency(medication.frequency) : '';
    const strengthText = medication.strength ? `of ${medication.strength}` : '';
    const routeText = medication.route ? `by ${medication.route}` : '';
    const text = [medication.quantity, medication.form, strengthText, routeText, frequencyText]
        .filter(Boolean)
        .join(' ');

    return text;
};
